<template>
  <div class="contract">
    <CCard class="card-table-emloyee">
      <CRow>
        <CCol sm="4" class="mb-mobile-2">
          <div class="form-group">
            <label>{{ $t("placeholder.label_employee_search_name") }}</label>
            <Select2
              class="select2-custom"
              v-model="searchData.employee_id"
              :options="employee_list"
              @change="search"
            />
          </div>
        </CCol>
        <CCol sm="4">
          <div class="form-group">
            <label>{{ $t("contract.type_contract") }}</label>
            <select
              class="form-control form-group"
              v-model="searchData.contract_type"
            >
              <option value="">{{ $t("employee.select_option") }}</option>
              <option
                v-for="(option, index) in contracts"
                :key="index"
                :value="option.code"
              >
                {{ option.name }}
              </option>
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="text-center btn-search">
          <CButton class="btn-search-employee" @click.prevent="search">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
          <CButton class="btn-reset" @click="resetForm"
            >{{ $t("button.label_action_reset") }}
          </CButton>
        </CCol>
      </CRow>
    </CCard>
    <CRow>
      <CCol sm="12">
        <CCard class="employee-table">
          <CCardBody>
            <div class="option-table">
              <div class="form-group">
                <select
                  class="form-control select-per-page"
                  v-model="searchData.itemsPerPage"
                  @change="search"
                >
                  <option
                    v-for="(item, index) in listItemsPerPage"
                    :value="item"
                    :key="index"
                    >{{ item }}
                  </option>
                </select>
              </div>
              <template
                v-if="employeeContract.data && employeeContract.data.length > 0"
              >
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ $t("commons.label_text_to") }}
                  {{ searchData.paginate.to }}
                  {{ $t("commons.label_text_of") }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
              <template v-else>
                <div class="show-text-table">
                  {{ $t("commons.label_text_show") }}
                  {{ searchData.paginate.from }}
                  {{ searchData.paginate.to }}
                  {{ searchData.paginate.totalRecord }}
                  {{ $t("commons.label_text_entries") }}
                </div>
              </template>
            </div>
            <div class="table-responsive">
              <table class="table table-mobile table-tablet">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">
                      {{ $t("employee.label_employee_code") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_name") }}
                    </th>
                    <th scope="col">
                      {{ $t("contract.type_contract") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_date_start") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_resignation_date") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_foot") }}
                    </th>
                    <th scope="col">
                      {{ $t("employee.label_employee_division") }}
                    </th>
                    <th scope="col" style="width: 150px;">
                      {{ $t("employee.label_employee_action") }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <template
                    v-if="
                      employeeContract.data && employeeContract.data.length > 0
                    "
                  >
                    <tr
                      v-for="(item, index) in employeeContract.data"
                      :key="index"
                    >
                      <th scope="row">
                        {{ getNumberRow(employeeContract, index) }}
                      </th>
                      <td>{{ item.id }}</td>
                      <td>{{ item.name }}</td>
                      <td>
                        <ul>
                          <li
                            v-for="(employee_contracts,
                            key) in item.contract_employees"
                            :key="key"
                          >
                            <template
                              v-if="
                                parseInt(item.id) ===
                                  parseInt(employee_contracts.employee_id)
                              "
                            >
                              {{
                                contracts[employee_contracts.contract_code].name
                              }}
                            </template>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul>
                          <li
                            v-for="(employee_contracts,
                            key) in item.contract_employees"
                            :key="key"
                          >
                            <template
                              v-if="
                                parseInt(item.id) ===
                                  parseInt(employee_contracts.employee_id)
                              "
                            >
                              {{ employee_contracts.start_date | formatDate }}
                            </template>
                          </li>
                        </ul>
                      </td>
                      <td>
                        <ul>
                          <li
                            v-for="(employee_contracts,
                            key) in item.contract_employees"
                            :key="key"
                          >
                            <template
                              v-if="
                                parseInt(item.id) ===
                                  parseInt(employee_contracts.employee_id)
                              "
                            >
                              {{ employee_contracts.end_date | formatDate }}
                            </template>
                          </li>
                        </ul>
                      </td>
                      <td>{{ item.foot }}</td>
                      <td>{{ item.division }}</td>
                      <td style="width: 180px">
                        <span class="mr-1"></span>
                        <router-link
                          :to="{
                            name: 'contracts.update',
                            params: { id: item.id }
                          }"
                          tag="a"
                        >
                          <CButton
                            color="primary"
                            variant="outline"
                            square
                            size="sm"
                          >
                            {{ $t("button.label_action_edit") }}
                          </CButton>
                        </router-link>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="12" class="text-center">
                        {{ $t("table.label_data_not_found") }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
          <CPagination
            :activePage.sync="searchData.paginate.currentPage"
            :pages="searchData.paginate.totalPage"
            @update:activePage="changePage"
            size="sm"
            align="center"
          />
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_contract_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      listEmployeeContracts: [],
      searchData: {
        contract_type: "",
        employee_id: "",
        itemsPerPage: 10,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 0,
          totalRecord: 0,
          perPage: 0
        }
      }
    };
  },

  computed: {
    ...mapGetters({
      employees: "contract-employee/employees",
      contracts: "contract-employee/contracts",
      employeeContract: "contract-employee/employeeContract",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "contract-employee/pagination"
    })
  },

  methods: {
    ...mapActions("layout", ["setLoading"]),

    resetForm() {
      this.searchData.employee_id = "";
      this.searchData.contract_type = "";
    },

    getNumberRow(data, index) {
      return (data.current_page - 1) * data.per_page + index + 1;
    },

    async fetchContractData() {
      await this.$store.dispatch("contract-employee/fetchContractEmployee", {
        optionPage: this.searchData.itemsPerPage,
        currentPage: this.searchData.paginate.currentPage,
        contract_type: this.searchData.contract_type,
        employee_id: this.searchData.employee_id
      });
      this.searchData.paginate = this.pagination;
      this.listEmployeeContracts = this.employeeContract.data;
    },

    async search() {
      this.setLoading(true);
      try {
        await this.fetchContractData();
        this.setLoading(false);
      } catch {
        this.setLoading(false);
      }
    },

    changePage(page) {
      this.fetchContractData(this.searchData.itemsPerPage, page);
    }
  },

  async created() {
    await this.$store.dispatch("contract-employee/getCommonsData");
    this.fetchContractData();
  },

  watch: {
    employees(employeeList) {
      this.employee_list = employeeList.map((employee)=> { 
        let splitSpaceString = employee.text.split(" ");
        let newStringEmail = splitSpaceString[splitSpaceString.length-1];
        let newStringName = splitSpaceString[splitSpaceString.length-2];
        let newArray = ((splitSpaceString.slice(0, splitSpaceString.length-2)).map(([i]) =>i)).join('');
        let numberPattern = /\d+/g;
        if(newStringEmail.match(numberPattern)=== null){
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + ")"
          }
        }
        else {
          return {
            id: employee.id,
            text: employee.name + " (" + newStringName + " " + newArray + newStringEmail.match(numberPattern) + ")"
          }
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.contract {
  margin: -2rem -30px 0 -30px;

  .btn-search {
    margin-top: 20px;
  }

  .card-table-emloyee {
    padding: 30px;

    .select2-container--default {
      border: 1px solid !important;
      color: #e4e6ea !important;
      border-radius: 4px !important;
    }
  }

  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }

  .employee-table {
    margin: 0 20px 0 30px;
  }

  .select-per-page {
    width: 70px;
  }

  .option-table {
    display: flex;
    justify-content: space-between;
  }

  table.table {
    th {
      vertical-align: middle !important;
    }

    td {
      vertical-align: middle !important;

      ul {
        margin-bottom: 0px;
        list-style-type: none;
        padding-left: 0px;

        li {
          text-align: left;
        }
      }
    }
  }
}
</style>
<style>
table .btn {
  min-width: auto;
}

.select2.select2-container {
  width: 100%;
}

.select2-custom .select2-selection {
  font-size: 0.875rem;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  height: calc(1.5em + 0.75rem + 2px);
  display: block;
  line-height: 1.5;
  background-clip: padding-box;
  border: 1px solid #d8dbe0;
  color: #768192;
  background-color: #fff;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select2-custom .select2-selection:focus {
  color: #768192;
  background-color: #fff;
  border-color: #958bef;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
}

th,
td {
  vertical-align: top !important;
}
@media only screen and (max-device-width: 767px) {
  .contract .employee-table[data-v-2f63e007] {
    margin: 0 1.25rem;
  }
  .mb-mobile-2 {
    margin-bottom: 0.5rem;
  }
  .show-text-table {
    margin-left: 20px;
  }
  .table-mobile {
    width: 1100px;
    overflow-x: scroll;
  }
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .table-tablet {
    width: 1100px;
    overflow-x: scroll;
  }
}
</style>
<style lang="scss">
@media only screen and (max-device-width: 767px) {
  span.select2.select2-container.select2-container--default {
    width: 100% !important;
  }
}
</style>
